import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JiraWidgetService {
  private readonly scriptId = 'jsd-widget-script';
  private readonly iframeId = 'jsd-widget';

  constructor(@Inject(DOCUMENT) private document: Document) {}

  public load(): void {
    if (
      this.document.getElementById(this.scriptId) ||
      this.document.querySelector('script[data-jsd-embedded]')
    ) {
      return;
    }

    const script = this.document.createElement('script');
    script.id = this.scriptId;
    script.type = 'text/javascript';
    script.async = true;
    script.setAttribute('data-jsd-embedded', '');
    script.setAttribute('data-key', environment.JIRA_WIDGET_DATA_KEY);
    script.setAttribute('data-base-url', 'https://jsd-widget.atlassian.com');
    script.src = 'https://jsd-widget.atlassian.com/assets/embed.js';
    script.onload = () => {
      this.document.dispatchEvent(new Event('DOMContentLoaded'));
    };

    this.document.head.appendChild(script);
  }

  public remove(): void {
    const script =
      this.document.getElementById(this.scriptId) ||
      this.document.querySelector('script[data-jsd-embedded]');

    script?.remove();
    this.document.getElementById(this.iframeId)?.remove();
  }
}
